import {ChangeDetectionStrategy, Component, Input,} from "@angular/core";
import {AgentModel} from "../../models/agent.model";

require('./agent-assistant-mode.scss');
@Component({
  standalone: false,
  selector: 'app-agent-assistant-mode',
  templateUrl: './agent-assistant-mode.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentAssistantModeComponent {

  @Input() agent: AgentModel;

  constructor() {
  }

}
